module.exports = __webpack_public_path__ + "c23d108b4d14a66c1f776bc0e6d9728f.svg";